import API from '@Modules/Authenticate/configs/api';
import apiMethod from '@utility/api_method';

export const signIn = async ({ ...payload }) => {
  try {
    const { data } = await apiMethod.post(`${API.AUTHENTICATE_LOGIN}`, payload);
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};
export const signOut = async (refreshToken) => {
  try {
    const { data } = await apiMethod.post(`${API.AUTHENTICATE_LOGOUT}`, { refreshToken : refreshToken });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};
